import { useRef, useEffect } from 'react';

const TableResizeHandler = ({ height, width, onResize }) => {
    const stateRef = useRef();
    useEffect(() => {
        if (!stateRef.current) {
            stateRef.current = true;
            onResize &&
                onResize({
                    width,
                    height,
                });
        }
    }, [height, onResize, width]);
    return null;
};

export { TableResizeHandler as default };
//# sourceMappingURL=TableResizeHandler.js.map
